import * as types from "../types/pageTypes";

export const setPlayingAction = currentlyPlaying => ({
  type: types.SET_PLAYING,
  currentlyPlaying
});

export default () => {};
